import { useMemo } from 'react';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useSortedProductInventory } from '../../v2/hooks/inventory/useSortedProductInventory';
import { useOwnedBundleForProduct } from '../../v2/hooks/inventory/useProductInventory';
import { useAppSelector } from '../../reducers';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { getNavItemForProductLine } from '../../utils/routingUtils';
import BillingNameTitle from './BillingNameTitle';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UnlockAIContentLayout from './UnlockAIContentLayout';
import { useHighestProductLevelFromInventory } from '../../v2/hooks/inventory/useHighestProductLevel';
import { jsx as _jsx } from "react/jsx-runtime";
const UnlockAIContent = () => {
  const isPreSeats = !useAppSelector(isUngatedForSeatsSelector);
  const {
    sortedProductInventory
  } = useSortedProductInventory();
  const {
    highestProductLevel
  } = useHighestProductLevelFromInventory();
  const firstProduct = sortedProductInventory[0];
  const skuId = firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.skuId;

  // Get bundle type for the first product if it exists
  const {
    bundleType
  } = useOwnedBundleForProduct({
    apiName: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.productApiName
  });
  const subscreen = useMemo(() => {
    const isBundle = !!(firstProduct !== null && firstProduct !== void 0 && firstProduct.bundle);
    if (isBundle) {
      if (bundleType === 'MARKETING_PLUS_SUITE') {
        return NavItemEnum.MARKETING_PLUS;
      }
      if (bundleType === 'CRM_SUITE') {
        return NavItemEnum.SUITE;
      }
    }
    const productLine = firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.productLine;
    if (!productLine) {
      return NavItemEnum.SUITE;
    }
    return getNavItemForProductLine(productLine);
  }, [firstProduct, bundleType]);
  const title = useMemo(() => {
    if (highestProductLevel === 'STARTER') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.unlockAI.title.withStarter"
      });
    }
    if (isPreSeats) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.unlockAI.title.withHubSpot"
      });
    }
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "pricingPage.pages.hubspot-credits.unlockAI.title.withBillingName",
      options: {
        billingName: /*#__PURE__*/_jsx(BillingNameTitle, {
          skuId: skuId
        })
      }
    });
  }, [highestProductLevel, isPreSeats, skuId]);
  return /*#__PURE__*/_jsx(UnlockAIContentLayout, {
    subscreen: subscreen,
    title: title
  });
};
export default UnlockAIContent;